import { Record, RecordOf } from 'immutable';

import { Action } from 'redux/types';
import { PostStatus } from '../constants';
import { Type } from './action-types';

export interface BlueskyPostMessageData {
  tokenInfo: {
    accessToken: string;
    accessTokenSecret: string;
    idToken: string;
    provider: 'bluesky';
    providerUserId: string;
  };
}

export type BlueskyAuthData = Pick<
  BlueskyPostMessageData['tokenInfo'],
  'accessToken' | 'accessTokenSecret' | 'idToken' | 'providerUserId'
>;

interface State extends BlueskyAuthData {
  accessToken: string;
  accessTokenSecret: string;
  postStatus: PostStatus;
  profileImageUrl: string;
  socialShareId: number;
  username: string;
  isLoadingUser: boolean;
}

export type BlueskyState = RecordOf<State>;

export const blueskyStateFactory = Record<State>({
  accessToken: undefined,
  accessTokenSecret: undefined,
  idToken: undefined,
  postStatus: undefined,
  profileImageUrl: undefined,
  providerUserId: undefined,
  socialShareId: undefined,
  username: undefined,
  isLoadingUser: false,
});

type GetBlueskyUserRequestAction = Action<Type.BLUESKY_USER_DATA_GET_REQUEST>;
type GetBlueskyUserSuccessAction = Action<
  Type.BLUESKY_USER_DATA_GET_SUCCESS,
  {
    username: string;
    profileImageUrl: string;
  }
>;
type GetBlueskyUserFailureAction = Action<Type.BLUESKY_USER_DATA_GET_FAILURE>;

type AwaitGetUserRequestAction = Action<
  Type.BLUESKY_USER_DATA_GET_AWAIT_REQUEST
>;
type AwaitGetUserSuccessAction = Action<
  Type.BLUESKY_USER_DATA_GET_AWAIT_SUCCESS
>;
type AwaitGetUserFailureAction = Action<
  Type.BLUESKY_USER_DATA_GET_AWAIT_FAILURE
>;

type ClearBlueskyUserAction = Action<Type.BLUESKY_USER_DATA_CLEAR>;

type PostVideoRequestAction = Action<Type.BLUESKY_VIDEO_POST_REQUEST>;
type PostVideoFailureAction = Action<Type.BLUESKY_VIDEO_POST_FAILURE>;
type PostVideoSuccessAction = Action<
  Type.BLUESKY_VIDEO_POST_SUCCESS,
  {
    socialShareId: number;
  }
>;

type AwaitPostRequestAction = Action<Type.BLUESKY_VIDEO_POST_AWAIT_REQUEST>;
type AwaitPostSuccessAction = Action<Type.BLUESKY_VIDEO_POST_AWAIT_SUCCESS>;
type AwaitPostFailureAction = Action<Type.BLUESKY_VIDEO_POST_AWAIT_FAILURE>;

export type BlueskyAuthorizeSuccessAction = Action<
  Type.BLUESKY_AUTHORIZE_SUCCESS,
  BlueskyAuthData
>;

export type BlueskyAction =
  | GetBlueskyUserRequestAction
  | GetBlueskyUserSuccessAction
  | GetBlueskyUserFailureAction
  | ClearBlueskyUserAction
  | PostVideoRequestAction
  | PostVideoSuccessAction
  | PostVideoFailureAction
  | BlueskyAuthorizeSuccessAction
  | AwaitPostRequestAction
  | AwaitPostSuccessAction
  | AwaitPostFailureAction
  | AwaitGetUserRequestAction
  | AwaitGetUserSuccessAction
  | AwaitGetUserFailureAction;
